import { JOURNEY_BUILDER } from 'constants/actionTypes';

export default (state = {}, action = {}) => {
  const updateState = changes => ({ ...state, ...changes });

  switch (action.type) {
    case JOURNEY_BUILDER.UI.SHOW_EDIT_DETAILS:
      return updateState({
        showEditDetails: true,
      });
    case JOURNEY_BUILDER.UI.HIDE_EDIT_DETAILS:
      return updateState({
        showEditDetails: false,
      });
    case JOURNEY_BUILDER.UI.DISPLAY_BANNER: {
      const dismissible =
        action.payload?.bannerDismissible !== undefined
          ? action.payload.bannerDismissible
          : true;

      return updateState({
        reporting: true,
        showBanner: true,
        bannerDismissible: dismissible,
      });
    }
    case JOURNEY_BUILDER.UI.HIDE_BANNER:
      return updateState({
        reporting: false,
        showBanner: false,
      });
    case JOURNEY_BUILDER.UI.TOGGLE_FINISH_EDITING:
      return updateState({
        disableFinishEditing: action.payload,
      });
    case JOURNEY_BUILDER.UI.SHOW_DELETE_CONFIRMATION_MODAL:
      return updateState({
        showDeleteConfirmationModal: true,
      });
    case JOURNEY_BUILDER.UI.HIDE_DELETE_CONFIRMATION_MODAL:
      return updateState({
        showDeleteConfirmationModal: false,
      });
    default: {
      return state;
    }
  }
};
